var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepper-input-summary"},[_c('typography',{staticClass:"stepper-count",attrs:{"type":"h2","no-margin":"","bold":""}},[_vm._v(" "+_vm._s(_vm.count)+" ")]),_c('typography',{attrs:{"light":"","no-margin":""}},[_vm._v(" Total ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }